<div class="container-fluid offer-details">
    <div class="row breadcrumb-wrapper">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="container">
                <div class="row">
                    <!--Breadcrumb-->
                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <!-- <app-breadcrumb [data]="breadcrumbData"></app-breadcrumb> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row offer-details-row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="container">
                <h1 class="page-sub-title mb-4 mt-4">Offer Details</h1>
                <div class="row c-box-row mb-4">
                    <div class="c-box">
                        <div class="box">

                            <div class="box-top-content">
                                <div class="ellipse ellipse-1"></div>
                                <div class="ellipse ellipse-2"></div>
                                <!-- <div class="ellipse ellipse-7"></div>
                                <div class="ellipse ellipse-8"></div> -->
                                <div class="brad-img">
                                  <img class="img-fluid" [ngStyle]="setFinancierImgUrl(offerData[0]?.financierId) === 'assets/fni-assets/images/yes-bank-logo.svg' ? {'width': '90%'} : {}" alt="{{offerData[0]?.financierDetails?.crmFinancierName}}"
                                        loading="lazy" src={{setFinancierImgUrl(offerData[0]?.financierId)}}>
                                    <!-- <img [src]='environment1 + "assets/images/brand-logo-1.png"' class="img-fluid" alt="" loading="lazy"> -->
                                </div>

                            </div>
                            <div class="box-bottom-content">
                                <div class="ellipse ellipse-5"></div>
                                <div class="ellipse ellipse-6"></div>
                                <h5>{{ offerData[0]?.financierSchemeName}}</h5>
                                <!-- <h6>For Captive Customers</h6> -->
                                <div class="offer-available">
                                    <span>Offer Available on</span><br>
                                    <span style="cursor: pointer;color: #333;" (click)="goToRelatedProduct()">{{offeron}}</span>
                                </div>
                                <div class="offer-desc row">
                                    <div class="col-md-8 col-lg-8 col-12">
                                        <span>Offer Description</span>
                                        <p style="cursor: pointer;">{{offerData[0]?.description}}</p>
                                    </div>
                                    <div class="row col-md-4 col-lg-4 col-12">
                                        <div class="col-6  d-sm-block text-sm-end">
                                            <button type="button"
                                                class="btn btn-primary btn-lg btn-grad-primary btn-brand w-100 cursor-pointer"
                                                data-toggle="tooltip" data-placement="top"
                                                title="Click here togo back" (click)="goBack()">Go Back
                                            </button>
                                        </div>
                                        <div class="col-6 d-sm-block text-sm-end">
                                            <button type="button" data-bs-toggle="modal"
                                                data-bs-target="#VasRazorPayModal" *ngIf="productDetailListvisible"
                                                class="btn btn-primary btn-lg btn-grad-primary btn-brand w-100"
                                                data-toggle="tooltip" data-placement="top"
                                                title="Click here for Confirm Booking" (click)="gotobookNow(offerData)">Proceed
                                            </button>
                                        </div>

                                    </div>

                                </div>

                                <div class="ellipse ellipse-3"></div>
                                <div class="ellipse ellipse-4"></div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="row box-data">
                    <div class="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 box-item">
                        <!-- <span>Loan Amount</span> -->
                        <span *ngIf="offerData[0]?.ltv">LTV</span>
                        <div *ngIf="offerData[0]?.ltv" >{{offerData[0]?.ltv}}%</div>
                    </div>
                    <div class="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 box-item">
                        <span *ngIf="offerData[0]?.irr">Interest Rate</span>
                        <div *ngIf="offerData[0]?.irr" >{{offerData[0]?.irr}}% Onwards</div>
                    </div>
                    <div class="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 box-item">
                        <span *ngIf="offerData[0]?.tenure">Tenure</span>
                        <div *ngIf="offerData[0]?.tenure">{{offerData[0]?.tenure}} Months</div>
                    </div>
                    <div class="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 box-item">
                        <span *ngIf="offerData[0]?.schemeInfo?.processingFee">Processing fees</span>

                        <div *ngIf="offerData[0]?.schemeInfo?.processingFee"><span *ngIf="!offerData[0]?.schemeInfo?.processingFee.includes('%')">₹</span>
                            {{offerData[0]?.schemeInfo?.processingFee}}</div>
                    </div>
                    <div class="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 box-item">
                        <span *ngIf="offerData[0]?.emiPerLac">EMI Starting from</span>
                        <div>{{offerData[0]?.emiPerLac | currency:'INR':'symbol':'4.0-0'}}</div>
                    </div>
                    <div class="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 box-item">
                        <span *ngIf="offerData[0]?.schemeInfo?.moratorium">Moratorium</span>
                        <div>{{offerData[0]?.schemeInfo?.moratorium}}</div>
                    </div>
                </div>
                <div class="faq-sec">
                    <h1 class="page-sub-title cv-text-dark mb-0">
                        Frequently Asked Questions (FAQs)
                    </h1>
                    <div class="faq mt-4 mb-4">
                        <div class="accordion accordion-flush" id="faqCollapse">
                            <div class="accordion-item" *ngFor="let faq of helpList | paginate: {
                                itemsPerPage: itemsPerPage,
                                currentPage: currentPage,
                                totalItems: totalItems,
                                id: 'faq'
                              }; let id = index">
                                <h1 class="accordion-header" id="faq-1">
                                    <a class="accordion-button collapsed remove" type="button" data-bs-toggle="collapse"
                                        aria-expanded="true" aria-controls="faq-C" href="#faq-C-{{id}}">
                                        {{faq.question}}
                                    </a>
                                </h1>
                                <div id="faq-C-{{id}}" class="accordion-collapse collapse" aria-labelledby="faq-c"
                                    data-bs-parent="#faqCollapse">
                                    <div class="accordion-body">
                                        {{faq.answer}}
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <!-- <app-emi-calculator [productPrice]="productPrice"></app-emi-calculator> -->
                <!-- <div class="offer-terms-condition">
                    <h1 class="page-sub-title mb-4">Offer Terms & Conditions</h1>
                    <div class="content">
                        <ul>
                            <li>Nulla Lorem mollit cupidatat irure. Laborum magna nulla duis ullamco cillum dolor. Voluptate exercitation incididunt aliquip deserunt reprehenderit elit laborum. </li>
                            <li>Nulla Lorem mollit cupidatat irure. Laborum magna nulla duis ullamco cillum dolor. Voluptate exercitation incididunt aliquip deserunt reprehenderit elit laborum. Aliqua id fugiat nostrud irure ex duis ea quis id quis ad et.</li>
                            <li>Nulla Lorem mollit cupidatat irure. Laborum magna nulla duis ullamco cillum dolor. Voluptate exercitation incididunt aliquip deserunt reprehenderit elit laborum.Sunt qui esse pariatur duis deserunt mollit dolore cillum minim tempor enim.</li>
                            <li>Voluptate exercitation incididunt aliquip deserunt reprehenderit elit laborum. Aliqua id fugiat nostrud irure ex duis ea quis id quis ad et. Sunt qui esse pariatur duis deserunt mollit dolore cillum minim tempor enim. Elit aute irure tempor cupidatat incididunt sint deserunt ut voluptate aute id deserunt nisi.</li>
                            <li> Sunt qui esse pariatur duis deserunt mollit dolore cillum minim tempor enim. Elit aute irure tempor cupidatat incididunt sint deserunt ut voluptate aute id deserunt nisi.</li>
                        </ul>
                    </div>
                </div> -->
            </div>
        </div>
    </div>

</div>
